export default __webpack_public_path__ + "static/media/pic3.cede8f09.jpg";